import { RootState } from "editor/src/store/index";

import findSpreadGroundImage from "editor/src/util/design/findSpreadGroundImage";

// GAPI-30848 — delegate to the shared tech-suffix-insensitive helper.
// See `findSpreadGroundImage` for the rationale: multi-tech spread names
// like `front-dtg` fall back to the catalogue's canonical-area scene
// (`front-dtf` / `front`) when no exact match exists.
const getSpreadBackgroundImage = (state: RootState, spreadName: string) =>
  findSpreadGroundImage(state.design.spreadBackgrounds, spreadName);

export default getSpreadBackgroundImage;
